/* ------------------------------------------------------------------
   Yoni Yoni - AJAX add to cart for product CARDS

   WHY THIS EXISTS
   Product cards must NOT contain a real {% form 'product' %}. Seal
   Subscriptions injects its "one-time / subscribe & save" widget into every
   element it recognises as a product form, which on a grid of cards means a
   subscription widget dumped into each card, breaking the layout.

   So cards use a plain button carrying data-yy-add + data-yy-variant, and
   this script posts to /cart/add.js. The product PAGE keeps its real form,
   which is where the Seal widget SHOULD appear.
   ------------------------------------------------------------------ */
(function () {
  function refreshCartCount(count) {
    document.querySelectorAll('[data-yy-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    var badge = document.querySelector('.yy-hd__badge');
    if (badge) badge.textContent = count;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-yy-add]');
    if (!btn) return;

    e.preventDefault();
    var id = btn.getAttribute('data-yy-variant');
    if (!id) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-yy-adding') || 'adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshCartCount(cart.item_count);
        btn.textContent = btn.getAttribute('data-yy-added') || 'added';
        document.dispatchEvent(new CustomEvent('yy:cart:updated', { detail: cart }));
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        btn.textContent = 'try again';
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 2000);
      });
  });
})();
